import React from "react";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
const FoodOrderHours = ({
  selectedHours,
  Hours,
  Minutes,
  calculateTotalValue,
  handleOnChangeHours,
  parentIndex,
}) => {
  const { t } = useTranslation();
  return (
    <div className="hour-selection-inner-wrapper">
      <div className="heading">{t("Hours")}</div>
      <div className="hour-select">
        <span>{t("Open")}</span>
        <FormControl sx={{ m: 1, minWidth: 76, maxWidth: 76 }} size="small">
          <Select
            value={`${selectedHours.OperationHoursStartInUtc?.Hour}`}
            onChange={(e) => handleOnChangeHours(e, "startHour", parentIndex)}
            displayEmpty
            IconComponent={KeyboardArrowDownIcon}
          >
            {Hours.map((v, index) => {
              return (
                <MenuItem value={v} key={`hour_${v}_${index}`}>
                  {("0" + v).slice(-2)}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <b>:</b>
        <FormControl sx={{ m: 1, minWidth: 76, maxWidth: 76 }} size="small">
          <Select
            value={`${selectedHours.OperationHoursStartInUtc?.Minute}`}
            onChange={(e) => handleOnChangeHours(e, "startMinute", parentIndex)}
            displayEmpty
            IconComponent={KeyboardArrowDownIcon}
          >
            <MenuItem value=""></MenuItem>
            {Minutes.map((v, index) => {
              return (
                <MenuItem value={v} key={`minute_${v}_${index}`}>
                  {("0" + v).slice(-2)}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </div>
      <div className="hour-select">
        <span>{t("Close")}</span>
        <FormControl sx={{ m: 1, minWidth: 76, maxWidth: 76 }} size="small">
          <Select
            value={`${selectedHours.OperationHoursStopInUtc?.Hour}`}
            onChange={(e) => handleOnChangeHours(e, "endHour", parentIndex)}
            displayEmpty
            IconComponent={KeyboardArrowDownIcon}
          >
            {Hours.map((v, index) => {
              return (
                <MenuItem value={v} key={`hour_close_${v}_${index}`}>
                  {("0" + v).slice(-2)}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <b>:</b>
        <FormControl sx={{ m: 1, minWidth: 76, maxWidth: 76 }} size="small">
          <Select
            value={`${selectedHours.OperationHoursStopInUtc?.Minute}`}
            onChange={(e) => handleOnChangeHours(e, "endMinute", parentIndex)}
            displayEmpty
            IconComponent={KeyboardArrowDownIcon}
          >
            {Minutes.map((v, index) => {
              return (
                <MenuItem value={v} key={`minute_close_${v}_${index}`}>
                  {("0" + v).slice(-2)}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </div>
      <div className="total-hours">
        <span>{t("Total")} :</span>
        <span>{calculateTotalValue(parentIndex)}</span>
      </div>
    </div>
  );
};

export default FoodOrderHours;
